<template>
  <div class="full-image" v-if="show" :before-close="close" :modal="true">
    <div class="mask" @click="close"></div>
    <div class="image-box" @wheel="handleWheel" @dblclick="handleDblClick">
      <img
          :src="url"
          :style="imageStyle"
          @mousedown="startDrag"
          @mousemove="onDrag"
          @mouseup="endDrag"
          @mouseleave="endDrag"
      />
    </div>
    <div class="controls" v-if="scale !== 1">
      <button @click="resetScale">重置</button>
    </div>
    <div class="close" @click="close"><i class="el-icon-close"></i></div>
  </div>
</template>

<script>
export default {
  name: "fullImage",
  data() {
    return {
      show: false,
      url: '',
      scale: 1,           // 缩放比例
      maxScale: 5,        // 最大缩放比例
      minScale: 0.1,      // 最小缩放比例
      isDragging: false,   // 是否正在拖拽
      startX: 0,
      startY: 0,
      imgStartX: 0,
      imgStartY: 0,
      posX: 0,
      posY: 0,
      startPosX: 0,
      startPosY: 0
    }
  },
  computed: {
    imageStyle() {
      return {
        transform: `translate(-50%, -50%) translate(${this.posX}px, ${this.posY}px) scale(${this.scale})`,
        cursor: this.isDragging ? 'grabbing' : (this.scale > 1 ? 'grab' : 'default')
      }
    }
  },
  methods: {
    open(url) {
      this.show = true;
      this.url = url;
      this.resetScale();  // 打开时重置缩放
      document.addEventListener('keydown', this.handleKeyDown);
    },
    close() {
      this.show = false;
      document.removeEventListener('keydown', this.handleKeyDown);
    },
    handleKeyDown(event) {
      if (event.key === 'Escape' || event.keyCode === 27) {
        this.close();
      }
    },
    // 鼠标滚轮缩放
    handleWheel(event) {
      event.preventDefault();
      const delta = event.deltaY > 0 ? -0.1 : 0.1;
      this.scale = Math.min(this.maxScale, Math.max(this.minScale, this.scale + delta));
    },
    // 双击缩放
    handleDblClick() {
      if (this.scale === 1) {
        this.scale = 2;
      } else {
        this.resetScale();
      }
    },
    // 重置缩放
    resetScale() {
      this.scale = 1;
      this.posX = 0;
      this.posY = 0;
    },
    // 开始拖拽
    startDrag(event) {
      if (this.scale <= 1) return;
      this.isDragging = true;
      this.startX = event.clientX;
      this.startY = event.clientY;
      this.startPosX = this.posX;
      this.startPosY = this.posY;
      event.preventDefault();
    },
    // 拖拽中
    onDrag(event) {
      if (!this.isDragging) return;
      const dx = event.clientX - this.startX;
      const dy = event.clientY - this.startY;
      this.posX = this.startPosX + dx;
      this.posY = this.startPosY + dy;
    },
    // 结束拖拽
    endDrag() {
      this.isDragging = false;
    }
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }
}
</script>

<style lang="scss">
.full-image {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 9999;

  .mask {
    position: fixed;
    width: 100%;
    height: 100%;
    background: black;
    opacity: 0.5;
  }

  .image-box {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;

    img {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      max-height: 100%;
      max-width: 100%;
      transition: transform 0.1s ease;
    }
  }

  .controls {
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10000;

    button {
      background: rgba(0, 0, 0, 0.7);
      color: white;
      border: none;
      padding: 8px 16px;
      border-radius: 4px;
      cursor: pointer;
    }
  }

  .close {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 20px;
    right: 20px;
    cursor: pointer;
    background: #333;
    border-radius: 50%;
    padding: 10px;
    opacity: 0.5;
    z-index: 10000;

    i {
      font-weight: bold;
      font-size: 20px;
      color: white;
    }
  }
}
</style>
